import React, {Component} from 'react';
import _ from 'lodash'
import moment from 'moment'

class Aside extends Component {
    renderNotificationStatus(data,i){
        if(data.comment || (data.data && data.data.comment)){
            let message, date, id = null;
            if(data.data){
                message = data.data.message || null;
                date = data.data.comment.updated_at || null;
                id = data.data.comment.caso_id || null;
            }else{
                message = data.message || null;
                date = data.comment.updated_at || null;
                id = data.comment.caso_id || null;
            }
            return(
                <div key={i}>
                    <hr className="transparent mx-3 my-0"/>
                    <div
                        className="callout callout-warning m-0 py-3 callout-status"
                        onClick={() =>{ window.location.href = `/casos/${id}`}}
                    >
                        <div>{message}</div>
                        <small className="text-muted mr-3"><i className="fa fa-calendar"></i>&nbsp; {moment.parseZone(date).local().locale('es').format('D [de] MMM YYYY[,] h:mm')}</small>
                    </div>
                </div>
            )
        }else{
            let message, date, id = null;
            if(data.data){
                message = data.data.message || null;
                date = data.data.caso.updated_at || null;
                id = data.data.caso.id || null;
            }else{
                message = data.message || null;
                date = data.caso.updated_at || null;
                id = data.caso.id || null;
            }
            return(
                <div key={i}>
                    <hr className="transparent mx-3 my-0"/>
                    <div
                        className="callout callout-info m-0 py-3 callout-status"
                        onClick={() =>{ window.location.href = `/casos/${id}`}}
                    >
                        <div>{message}</div>
                        <small className="text-muted mr-3">
                            <i className="fa fa-calendar"></i>
                            &nbsp; {moment.parseZone(date).local().locale('es').format('D [de] MMM YYYY[,] h:mm')}
                        </small>
                    </div>
                </div>
            )
        }
    }
    renderAside(){
        if(_.isEmpty(this.props.notifications)){
            return(
            <div className="callout m-0 py-2 text-muted text-center bg-light text-uppercase">
                <small><b>No hay notificaciones pendientes</b></small>
            </div>)
        }
        return(
            <div>
                <div className="callout m-0 py-2 text-center bg-white text-uppercase">
                    <button
                        className="btn btn-link"
                        onClick={this.props.markAllNotifications}
                    >
                        <b><i className="fa fa-check-square-o" /> Marcar todas como leidas</b>
                    </button>
                </div>
                {this.props.notifications.map((notif, i) => {
                    return (
                        this.renderNotificationStatus(notif, i)
                    );
                })}
            </div>
        )
    }

    render() {
        return (
            <aside className="aside-menu">
                {this.renderAside()}
            </aside>
        )
    }
}

export default Aside;



// WEBPACK FOOTER //
// ./resources/assets/js/components/core/Aside/Aside.js